import { flowSteps } from "@/mocks/home";

export default function ReviewFlow() {
  return (
    <section id="flow" className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-medium tracking-wide text-secondary-700">
            审核机制
          </span>
          <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            从提交到展示，一条线索要走完这四步
          </h3>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            投稿后不会立刻公开，先经过编辑初筛与合规审核，确认安全与可核实后再进入曝光台。
          </p>
        </div>

        <ol className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {flowSteps.map((step) => (
            <li
              key={step.id}
              className="relative rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
            >
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-200">
                {step.step}
              </span>
              <h4 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">
                {step.title}
              </h4>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}